export const bowtieReducer: WidgetReducerType<any, any> = (state = [], message) => {
    // test for initialState calls
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message.type) {
        case 'start':
            return []

        case 'event':
            return message.events

        default:
            return state
    }
}
